var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "close_button", class: _vm.type }, [
    _c("div", { staticClass: "inner" }, [
      _c(
        "svg",
        {
          attrs: {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M2.41579 23.9262L0.082489 21.5929L9.41579 12.2596L0.082489 2.92616L2.41579 0.592865L11.7492 9.92616L21.0825 0.592865L23.4158 2.92616L14.0825 12.2596L23.4158 21.5929L21.0825 23.9262L11.7492 14.5929L2.41579 23.9262Z",
              fill: "#211752",
            },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }